import { LazyMotion, MotionConfig } from 'framer-motion';
import type { ReactNode } from 'react';

// Lazy-load Framer Motion features so the entry bundle stays small (the
// feature bundle resolves only when the first `m.*` component mounts).
// The import goes through ./framer-dom-animation (NOT the 'framer-motion'
// barrel): a dynamic import of the barrel would resolve to the same module
// this file statically imports, collapsing the feature bundle back into the
// eager chunk. See framer-dom-animation.ts for the full rationale.
const loadFeatures = () => import('./framer-dom-animation').then((res) => res.domAnimation);

/**
 * Central Framer Motion policy for the learner portal (a11y, WCAG 2.3.3).
 *
 * `reducedMotion="user"` makes every motion component in the tree honor the
 * device `prefers-reduced-motion` setting: transform/positional animations
 * are skipped (values jump to their target instantly) while other animations
 * still run. This is the single place motion is configured — keep all motion
 * consumers underneath it, and keep `strict` so unloaded feature bundles fail
 * loudly at runtime instead of silently misbehaving.
 */
export function MotionProvider({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={loadFeatures} strict>
        {children}
      </LazyMotion>
    </MotionConfig>
  );
}
